import {ChangeDetectionStrategy, Component, Input, ViewEncapsulation} from '@angular/core';
import {Candidate} from '../../../shared/models/candidate';
import {LogUtils} from '../../../shared/utils/log-utils';
import {Test} from '../../../shared/models/test';
import {TestType} from '../../../shared/enums/test-type';
import {TestBundle} from '../../../shared/models/test-bundle';
import {CommonUtils} from '../../../shared/utils/common-utils';
import {Duration} from 'moment';

@Component({
    selector: 'app-candidate-test-cti',
    templateUrl: './candidate-test-cti.component.html',
    styleUrls: ['./candidate-test-cti.component.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CandidateTestCtiComponent {
    public selectedTab = 0;

    @Input() candidate: Candidate = null;
    @Input() selectedBundle = 0;

    get test(): Test {
        return this.bundle && this.bundle.tests ? this.bundle.tests.find(test => test.type === TestType.CTI) : {} as Test;
    }

    get bundle(): TestBundle {
        if (this.candidate && CommonUtils.isNotEmpty(this.candidate.bundles)) {
            return this.candidate.bundles[this.selectedBundle];
        }
        return {} as TestBundle;
    }

    /**
     * result: { counts: object, result: object}
     */
    get result(): { counts: object, result: object } {
        try {
            return JSON.parse(this.test.result);
        } catch (e) {
            LogUtils.error(`Parse error for results: ${e.message}`);
            return null;
        }
    }

    get counts(): any {
        const result = this.result;
        return result ? result.counts : -1;
    }

    get analysis(): any {
        const result = this.result;
        return result ? result.result : -1;
    }

    get renderData(): boolean {
        return this.counts !== -1 && this.analysis !== -1;
    }

    get duration(): Duration {
        return CommonUtils.calculateDuration(this.test);
    }

    switchTab(index): void {
        this.selectedTab = index || 0;
    }
}
